(function () {
  const sectionSelector = '.stories-reviews';
  const youtubeSectionSelector = '.stories-reviews[data-has-youtube-iframes]';
  let isYouTubeAPIReady = false;

  const players = {
    youtube: {},
    vimeo: [],
    html5: []
  };

  function pauseAllOtherVideos(playingPlayer) {
    Object.values(players.youtube).forEach((player) => {
      if (player !== playingPlayer && typeof player.pauseVideo === 'function') {
        player.pauseVideo();
      }
    });

    [...players.vimeo, ...players.html5].forEach((player) => {
      if (player === playingPlayer) return;

      try {
        if (player.tagName === 'IFRAME') {
          player.contentWindow.postMessage('{"method":"pause"}', '*');
        } else {
          player.pause();
        }
      } catch (e) {
        /* ignore */
      }
    });
  }

  function onPlayerStateChange(event) {
    const container = event.target.getIframe().closest('.stories-reviews__video');
    if (!container) return;

    const playBtn = container.querySelector('button.stories-reviews__play');
    const preview = container.querySelector('.stories-reviews__video--preview');

    if (event.data === YT.PlayerState.PLAYING) {
      pauseAllOtherVideos(event.target);
      container.classList.add('video-is-playing');
      if (playBtn) playBtn.style.display = 'none';
      if (preview) preview.style.display = 'none';
      return;
    }

    container.classList.remove('video-is-playing');

    if (event.data === YT.PlayerState.ENDED) {
      if (playBtn) playBtn.style.display = '';
      if (preview) preview.style.display = '';
    }
  }

  function initYoutubePlayers() {
    document.querySelectorAll(`${youtubeSectionSelector} iframe.js-stories-reviews-youtube`).forEach((iframe) => {
      if (!iframe.id) {
        iframe.id = `stories-reviews-yt-${Math.random().toString(36).substring(7)}`;
      }

      if (players.youtube[iframe.id]) return;

      players.youtube[iframe.id] = new YT.Player(iframe.id, {
        events: {
          onStateChange: onPlayerStateChange
        }
      });
    });

    isYouTubeAPIReady = true;
  }

  const previousYouTubeReady = window.onYouTubeIframeAPIReady;
  window.onYouTubeIframeAPIReady = function () {
    if (typeof previousYouTubeReady === 'function') {
      previousYouTubeReady();
    }

    initYoutubePlayers();
  };

  function initStoriesReviews() {
    const sections = document.querySelectorAll(sectionSelector);
    if (!sections.length) return;

    sections.forEach((section) => {
      const videoContainers = section.querySelectorAll('.stories-reviews__video');

      videoContainers.forEach((container) => {
        const ytIframe = container.querySelector('iframe.js-stories-reviews-youtube');
        const vimeoIframe = container.querySelector('iframe.js-stories-reviews-vimeo');
        const html5Video = container.querySelector('video');
        const playBtn = container.querySelector('button.stories-reviews__play');

        if (vimeoIframe) players.vimeo.push(vimeoIframe);
        if (html5Video) players.html5.push(html5Video);

        if (!playBtn || (!ytIframe && !vimeoIframe && !html5Video)) return;

        playBtn.addEventListener('click', () => {
          if (container.classList.contains('video-is-playing')) return;

          const preview = container.querySelector('.stories-reviews__video--preview');
          playBtn.style.display = 'none';
          if (preview) preview.style.display = 'none';

          if (ytIframe) {
            if (!isYouTubeAPIReady) return;

            if (players.youtube[ytIframe.id]) {
              players.youtube[ytIframe.id].playVideo();
            }

            return;
          }

          const playerToStart = vimeoIframe || html5Video;
          pauseAllOtherVideos(playerToStart);
          container.classList.add('video-is-playing');

          if (vimeoIframe) {
            try {
              vimeoIframe.contentWindow.postMessage('{"method":"play"}', '*');
            } catch (e) {
              /* ignore */
            }
          } else if (html5Video) {
            html5Video.play();
          }
        });

        if (!html5Video) return;

        html5Video.addEventListener('play', () => {
          const btn = container.querySelector('button.stories-reviews__play');
          if (btn) btn.style.display = 'none';
          pauseAllOtherVideos(html5Video);
          container.classList.add('video-is-playing');
        });

        html5Video.addEventListener('pause', () => {
          container.classList.remove('video-is-playing');
        });

        html5Video.addEventListener('ended', () => {
          container.classList.remove('video-is-playing');
          const btn = container.querySelector('button.stories-reviews__play');
          const previewImg = container.querySelector('.stories-reviews__video--preview');
          if (btn) btn.style.display = '';
          if (previewImg) previewImg.style.display = '';
        });

        html5Video.addEventListener('fullscreenchange', () => {
          html5Video.style.objectFit = document.fullscreenElement === html5Video ? 'contain' : '';
        });

        html5Video.addEventListener('webkitfullscreenchange', () => {
          html5Video.style.objectFit =
            document.webkitFullscreenElement === html5Video ? 'contain' : '';
        });
      });
    });

    if (typeof YT !== 'undefined' && YT.Player) {
      initYoutubePlayers();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoriesReviews);
  } else {
    initStoriesReviews();
  }
})();
